
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16.3","height":"14.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.265.65H2.857A2.129 2.129 0 00.65 2.688v2.3m15 0v-2.3A2.1 2.1 0 0013.486.65h-2.451m0 13h2.445a2.123 2.123 0 002.17-2.072V9.317m-15 0v2.262a2.156 2.156 0 002.207 2.071h2.408","fill":"none","stroke":"#6b7786","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.3"}})])
          )
        }
      }
    